// extracted by mini-css-extract-plugin
export var light = "profList-module--light--prR+J";
export var listItem = "profList-module--list-item--hu3WI typography-module--body--LdsA5 typography-module--caps--HvwGR colors-module--color-body--wh0CY";
export var paragraph = "profList-module--paragraph--32Ad- typography-module--body--LdsA5 typography-module--margin-half-line-height--9DL8k";
export var section = "profList-module--section--cVIXY layout-module--section--80yNc";